export const getVerticalNameFromProductUid = <T extends string = 'CC' | 'PL'>(
  productUid: string = '',
) => {
  return productUid.split('.')[1] as T;
};
